<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <div class="row" v-if="contractData">
      <div class="col">
        <div class="generalTitleItemModal">Contrato</div>
        <a href="#" @click="downloadContrato()">
          <v-icon name="bi-download" scale="1.2" />
          &nbsp;
          <span class="text-muted"> {{$dateBackToFront(contractData.date, true)}}</span>
        </a>
      </div>
      <div class="col">
        <div class="generalTitleItemModal">Recibos</div>
        <div v-if="contractData.receipts">
          <div class="row" v-for="recibo in contractData.receipts" :key="recibo.number">
            <a href="#" @click="downloadContrato(recibo.number)">
              <v-icon name="bi-download" scale="1.1" />
              &nbsp;
              <span class="text-muted">{{recibo.number}}ª factura ({{recibo.paymentDate}})</span>
            </a>
          </div>
        </div>
        <div v-else class="alert alert-light p-0">
          Todavía no hay recibos
        </div>
      </div>
      <div v-if="!$store.state.roles.Backoffice_member_empresas" class="col">
        <div class="generalTitleItemModal">Recobros</div>
        <div v-if="contractData.receipts">
          <div class="row" v-for="recibo in contractData.receipts" :key="recibo.number">
            <a v-if="recibo.paymentDateCommission !== null" href="#" @click="downloadRecobro(recibo.number)">
              <v-icon name="bi-download" scale="1.1" />
              &nbsp;
              <span class="text-muted">{{recibo.number}}ª recobro ({{recibo.paymentDateCommission}})</span>
            </a>
          </div>
        </div>
        <div v-else class="alert alert-light p-0">
          No hay recobros
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>

import Modal from '../../../Shared/Modal.vue';
import axios from 'axios';
export default {
  name: 'Documents',
  props: [
    'id',
    'modalTitle',
    'class',
    'contractId'
  ],
  data() {
    return {
      classes: this.class,
      contractData: '',
    };
  },
  updated() {
    this.loadContractData();
  },
  components: {
    Modal,
  },
  methods: {
    loadContractData() {
      axios.get(`/contract/${this.contractId}`)
        .then((response) => {
          this.contractData = response.data;
        });
    },
    downloadContrato(month) {
      if (month == null) {
        axios.get(`/contract/document/${this.contractId}`)
          .then((response) => {
            window.open(response.data, '_blank');
          });
      } else {
        axios.get(`/contract/document/${this.contractId}/receipt/${month}`)
          .then((response) => {
            window.open(response.data, '_blank');
          });
      }

    },
    downloadRecobro(month) {
      axios.get(`/contract/document/commission/${this.contractId}/receipt/${month}`)
        .then((response) => {
          window.open(response.data, '_blank');
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>